import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
});

const getProfile = async () => {
  const res = await axios.get(`${API_URL}profile`, { headers: authHeaders() });
  return res.data;
};

// formData ma image hoy etle Content-Type axios pote set kare (multipart)
const updateProfile = async (formData) => {
  const res = await axios.post(`${API_URL}profile/update`, formData, {
    headers: authHeaders(),
  });
  return res.data;
};

const changePassword = async (data) => {
  const res = await axios.post(`${API_URL}profile/change-password`, data, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  });
  return res.data;
};

export default { getProfile, updateProfile, changePassword };